const environment: { [key: string]: null } = {
  production: null,
};

if (__DEVELOPMENT__) {
  environment.development = null;
}

if (__PRODTEST__) {
  environment.prodtest = null;
}

if (__TEST__) {
  environment.test = null;
}

// The first listed has higher precedence
const dimensions = {
  dimensions: [
    {
      skynet: {
        // office ip
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      lite: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      avif: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      webp: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      modern: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      remote: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      prerender: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      standalone: {
        '0': null, // eslint-disable-line quote-props
        '1': null, // eslint-disable-line quote-props
      },
    },
    {
      experience: {
        matchmaker: null,
        select: null,
        gift: null,
      },
    },
    {
      // we are using ISO 3166-1 alpha-2 for the acronyms (https://en.m.wikipedia.org/wiki/ISO_3166-1_alpha-2)
      // By continent
      country: {
        Asia: {
          'Middle East': {
            // IO: null,
            AE: null,
            BH: null,
            CY: null,
            EG: null,
            IL: null,
            IQ: null,
            IR: null,
            JO: null,
            KW: null,
            LB: null,
            OM: null,
            PS: null,
            QA: null,
            SA: null,
            SY: null,
            TR: null,
            YE: null,
          },
          'South Asia': {
            AF: null,
            BD: null,
            BT: null,
            IN: null,
            LK: null,
            MV: null,
            NP: null,
            PK: null,
          },
          'East Asia': {
            CN: null,
            HK: null,
            JP: null, // JAPAN (JPN)
            KP: null,
            KR: null,
            TW: null,
            MN: null,
          },
          'Southeast Asia': {
            BN: null,
            BU: null, // Reserved from 1989-12 to 2039-12., Burma (BU, BUR, 104) to Myanmar (MM MMR, 104)
            ID: null,
            KH: null,
            LA: null,
            MM: null,
            MY: null,
            PH: null,
            SG: null,
            TH: null,
            TL: null,
            VN: null,
          },
        },
        'Central America': {
          BZ: null,
          CR: null,
          GT: null,
          HN: null,
          NI: null,
          PA: null,
          SV: null,
        },
        'North America': {
          // AI: null,
          // AW: null,
          // BL: null,
          // BM: null,
          CA: null, // CANADA (CAN)
          CU: null,
          // CW: null,
          // GL: null,
          // GP: null,
          // KY: null,
          MX: null, // MEXICO (MEX)
          // MF: null,
          // MQ: null,
          // MS: null,
          // PM: null,
          // SX: null,
          // TC: null,
          US: null,
          // VG: null
        },
        Europe: {
          AT: null,
          // BE: null,
          // BG: null,
          // CY: null,
          // CZ: null,
          DE: null, // Germany (DEU)
          DK: null,
          // EE: null,
          // EL: null, // Greece
          ES: null, // Spain (ESP)
          FI: null,
          FR: null, // France (FRA)
          GB: null, // United Kingdom (UK)
          // GR: null, // Greece
          // HR: null,
          // HU: null,
          IE: null,
          IT: null,
          // LT: null,
          // LU: null,
          // LV: null,
          // MT: null,
          NL: null,
          // PL: null,
          // PT: null,
          // RO: null,
          SE: null,
          // SI: null,
          // SK: null,
          // AX: null,
          // FO: null,
          // GG: null,
          // GI: null,
          // IM: null,
          // IS: null,
          // JE: null,
          // LI: null,
          NO: null,
        },
        Oceania: {
          AU: null, // Australia (AUS)
          // NC: null,
          NZ: null,
          // PF: null,
          // PN: null,
          // WF: null
        },
        Africa: {
          BJ: null,
          GH: null,
          LR: null,
          // NE: null,
          // RE: null,
          SD: null,
          // SH: null,
          TN: null,
          // YT: null
        },
        'South America': {
          AR: null,
          BO: null,
          BR: null,
          CL: null,
          CO: null,
          EC: null,
          FK: null,
          GF: null,
          GY: null,
          PE: null,
          PY: null,
          SR: null,
          UY: null,
          VE: null,
        },
      },
    },
    {
      environment,
    },
  ],
};

export default dimensions;
